import "../../auto-mapper/AutoMapperProvider.js";
import { useAutoMapper } from "../../auto-mapper/hooks.js";
import { BackpackItem } from "../../contract/pam.js";
import "typesafe-actions";
import "rxjs";
import "rxjs/operators";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "redux-observable";
import "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../redux-folder/entity/epics.js";
import "normalizr";
import "../../redux-folder/entity/EntityProvider.js";
import "../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import { useViewInit } from "../../redux-folder/view/hooks.js";
import { BackpackViewModelKeysTypeName, BackpackQueryFieldsTypeName } from "./constants.js";
import { BackpackViewModel } from "./types.js";
function useBackpack({
  viewType,
  fields,
  displayName,
  cleanDelay = 0,
  realtimeMode,
  triggers,
  defaultFilters,
  defaultPaging,
  defaultSorting,
  validateFilter,
  syncWithUrl = false,
  backpackEntity
}) {
  const mapper = useAutoMapper();
  const queryFields = mapFields(fields);
  const {
    items: backpacks,
    totalCount,
    searchFilter,
    viewEntity: { filter: filterString },
    handlePageChange,
    handlePageSizeChange,
    handleSortChange,
    handleFilterChange
  } = useViewInit({
    viewType,
    entity: {
      entity: backpackEntity,
      fields: queryFields
    },
    displayName,
    realtime: realtimeMode ? { entity: backpackEntity, mode: realtimeMode, triggers } : null,
    defaultSorting: mapSorting(defaultSorting),
    defaultPaging,
    defaultFilters,
    syncWithUrl,
    validateFilter,
    cleanDelay
  });
  const currency = "USD";
  const items = backpacks?.map(
    (i) => mapper.tryMap(i, BackpackItem, BackpackViewModel, {
      extraArgs: () => ({
        currency
      })
    })
  );
  return {
    items: items?.map((i) => i.model),
    rawItems: items?.map((i) => ({ isValid: i.isModelValid, raw: i.rawModelString })),
    totalCount,
    searchFilter,
    filterString,
    handlePageChange,
    handlePageSizeChange,
    handleSortChange,
    handleFilterChange
  };
  function mapFields(fields2) {
    return mapper.map(
      fields2,
      BackpackViewModelKeysTypeName,
      BackpackQueryFieldsTypeName
    );
  }
  function mapField(field) {
    return mapFields([field])[0];
  }
  function mapSorting(sorting) {
    return sorting?.map((s) => ({ ...s, field: mapField(s.field) }));
  }
}
export {
  useBackpack
};
//# sourceMappingURL=hooks.js.map
